import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PlanScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/training-program", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-[#196644] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

